import Router from 'vue-router'
import Home from '../views/home'
import About from '../views/about'
import Busi from '../views/busi'
import Busi1 from '../views/busi1'
import Busi2 from '../views/busi2'
import Busi3 from '../views/busi3'
import Busi4 from '../views/busi4'
import Busi5 from '../views/busi5'
import Case from '../views/case'
import News from '../views/news'
import NewsList from '../views/newsList'
import NewsDetail from '../views/newsDetail'
import Join from '../views/join'
import Job from '../views/job'
import Contact from '../views/contact'
let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Home/:tab',
      name: 'HomeTab',
      component: Home
    },
    {
      path: '/About',
      name: 'About',
      component: About
    },
    {
      path: '/About/:tab',
      name: 'AboutTab',
      component: About
    },
    {
      path: '/Busi',
      name: 'Busi',
      component: Busi
    },
    {
      path: '/Busi1',
      name: 'Busi1',
      component: Busi1
    },
    {
      path: '/Busi2',
      name: 'Busi2',
      component: Busi2
    },
    {
      path: '/Busi3',
      name: 'Busi3',
      component: Busi3
    },
    {
      path: '/Busi4',
      name: 'Busi4',
      component: Busi4
    },
    {
      path: '/Busi5',
      name: 'Busi5',
      component: Busi5
    },
    {
      path: '/Case',
      name: 'Case',
      component: Case
    },
    {
      path: '/Join',
      name: 'Join',
      component: Join
    },
    {
      path: '/Job/:t',
      name: 'Job',
      component: Job
    },
    {
      path: '/Job',
      name: 'Job1',
      component: Job
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/News',
      name: 'News',
      component: News
    },
    {
      path: '/NewsCata/:q',
      name: 'NewsCata',
      component: NewsList
    },
    {
      path: '/NewsList/:ctype',
      name: 'NewsList',
      component: NewsList
    },
    {
      path: '/NewsDetail/:id',
      name: 'NewsDetail',
      component: NewsDetail
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    let loc = '/index/mobile.html#'
    loc += to.fullPath || '/'
    window.location.href = loc
    return
  }
  next()
})
export default router